import { useTranslation } from 'react-i18next';
import ReportActions from './ReportActions';
import { Report } from '../../types';
import Paypal from './Paypal';
import { Button } from '@mui/material';

type ReportProps = {
  report: Report;
  patientId: string;
};

const Report = ({ report, patientId }: ReportProps) => {
  const { t } = useTranslation();
  const invoiceLink = report?.fattura?.replace(/^\.\./, '') || '';

  return (
    <div className="mx-auto my-10 max-w-7xl">
      <div>
        <span className="font-bold">{t('username sample')}:</span> {report?.campione}
      </div>
      {report?.codice ? (
        <ReportActions report={report} patientId={patientId} />
      ) : (
        <div>
          <div className="my-4" dangerouslySetInnerHTML={{ __html: report?.messaggio }}></div>
        </div>
      )}
      {invoiceLink !== '' && (
        <div className="max-w-xl mt-6 mb-8">
          <Button
            fullWidth
            href={invoiceLink}
            target="new"
            variant="contained"
            color="warning"
            style={{ color: 'white' }}
          >
            {t('download invoice')}
          </Button>
        </div>
      )}
      <Paypal amount={report.importo} status={report.stato_pagamento} />
    </div>
  );
};

export default Report;
